var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"wEDC9sL3kVaruMI6qdnmY"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/list";

import { env } from '@lcsc-ui/utils/baseUrl';
import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  // Environment and release
  environment: env,
  release: `nextjs-list-app@${new Date().toISOString().split('T')[0]}`,

  // Sampling rates
  tracesSampleRate: env === 'pro' ? 0.001 : 0,
  sampleRate: env === 'pro' ? 0.001 : 0,

  // Integrations
  integrations: [
    Sentry.browserTracingIntegration({
      tracePropagationTargets: ['localhost', /^https:\/\/list\.szlcsc\.com/],
    }),
  ],

  // Tags
  initialScope: {
    tags: {
      component: 'nextjs-list-app',
      platform: 'web',
    },
  },

  // Ignore common errors
  ignoreErrors: [
    'Network Error',
    'NetworkError',
    'Script error.',
    'AbortError',
    'Non-Error promise rejection captured',
  ],

  // Filter sensitive data
  beforeSend(event) {
    // Filter development errors
    if (env !== 'pro') {
      const message = event.message || event.exception?.values?.[0]?.value || '';
      if (message.includes('webpack hot update') || message.includes('CORS')) {
        return null;
      }
    }

    // Filter sensitive data in production
    if (env === 'pro') {
      // Remove user PII
      if (event.user) {
        delete event.user.email;
        delete event.user.ip_address;
      }

      // Filter sensitive request data
      if (event.request?.data) {
        const sensitiveKeys = ['password', 'token', 'key', 'secret'];
        sensitiveKeys.forEach((key) => {
          if (event.request.data[key]) {
            event.request.data[key] = '[Filtered]';
          }
        });
      }
    }

    return event;
  },
});

export default Sentry;
